
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.522","height":"8.523"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30585","data-name":"Group 30585"}},[_c('g',{attrs:{"id":"Group_30579","data-name":"Group 30579","fill":"#262626"}},[_c('path',{attrs:{"id":"Path_21072","data-name":"Path 21072","d":"M4.255 8.523H.952a.917.917 0 01-.8-.5A1.158 1.158 0 010 7.429V5.47 3.495 1.11A1.12 1.12 0 01.379.218.86.86 0 01.955 0H3.408a.424.424 0 01.4.285.42.42 0 01-.385.564H1.157a.277.277 0 00-.3.306V7.343a.513.513 0 00.022.157.244.244 0 00.247.169h6.237a.28.28 0 00.3-.306v-.79c0-.484.005-.967 0-1.45a.428.428 0 11.855 0V7.404a1.168 1.168 0 01-.254.772.88.88 0 01-.7.343H4.255z","transform":"translate(0 -.001)"}}),_c('path',{attrs:{"id":"Path_21073","data-name":"Path 21073","d":"M11.231 1.537l-.037.033-2.15 2.149-.9.9a.457.457 0 01-.447.132.439.439 0 01-.349-.351.454.454 0 01.129-.439l.621-.621 1.09-1.091L10.536.9l.038-.044c-.031 0-.05-.005-.07-.005-.317 0-.634-.005-.951 0a.432.432 0 01-.425-.323.418.418 0 01.266-.5A.423.423 0 019.541 0h2.116a.42.42 0 01.407.277.42.42 0 01.03.157v2.11a.428.428 0 01-.283.413.421.421 0 01-.568-.376c-.006-.327 0-.655 0-.982v-.055l-.015-.007","transform":"translate(-3.578)"}})])])])
          )
        }
      }
    